// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Google Sheets Sync Logs Styles
 * Modern, responsive styles for sync logs management
 */

.google-sheets-sync-logs {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Header */
.logs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  padding: 24px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.header-content h2 {
  color: #2d3748;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  line-height: 1.2;
}

.header-content p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

.header-actions {
  display: flex;
  gap: 12px;
}

/* Statistics */
.logs-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.15),
    0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-card.completed .stat-icon {
  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);
}

.stat-card.failed .stat-icon {
  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);
}

.stat-card.in-progress .stat-icon {
  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);
}

.stat-card.pending .stat-icon {
  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);
}

.stat-icon {
  font-size: 2rem;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
}

.stat-content h3 {
  color: #4a5568;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stat-value {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Filters */
.logs-filters {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.filters-header h3 {
  color: #2d3748;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
}

.filters-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filter-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  align-items: end;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-group.filter-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  color: #4a5568;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-select,
.filter-input {
  padding: 12px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: white;
  color: #2d3748;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.filter-select:focus,
.filter-input:focus {
  outline: none;
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);
}

.filter-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.logs-summary {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 8px;
  border: 1px solid rgba(102, 126, 234, 0.2);
}

.summary-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: #3730a3;
}

/* Bulk Actions */
.bulk-actions {
  background: rgba(102, 126, 234, 0.1);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.bulk-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.selected-count {
  color: #2d3748;
  font-weight: 600;
  font-size: 0.9rem;
}

.bulk-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Logs Grid */
.logs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

/* Logs Table */
.logs-table-container {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
}

.logs-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  min-width: 1000px;
}

.logs-table thead {
  background: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}

.logs-table th {
  padding: 16px 12px;
  text-align: left;
  font-weight: 600;
  color: #374151;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}

.logs-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
  color: #374151;
}

.log-row {
  transition: background-color 0.2s ease;
}

.log-row:hover {
  background-color: #f8fafc;
}

.log-row:last-child td {
  border-bottom: none;
}

.sync-type-badge {
  background: #e0e7ff;
  color: #3730a3;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  display: inline-block;
}

.datetime-info {
  font-size: 0.85rem;
  color: #374151;
  line-height: 1.4;
}

.duration-info {
  font-size: 0.85rem;
  color: #6b7280;
  font-weight: 500;
}

.members-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.members-count {
  font-size: 0.85rem;
  color: #374151;
  font-weight: 500;
}

.failed-count {
  font-size: 0.75rem;
  color: #dc2626;
}

.success-rate {
  font-size: 0.85rem;
  color: #059669;
  font-weight: 600;
}

.triggered-by {
  font-size: 0.85rem;
  color: #6b7280;
}

.notes-info {
  max-width: 200px;
}

.notes-text {
  font-size: 0.8rem;
  color: #6b7280;
  line-height: 1.3;
  display: block;
  word-wrap: break-word;
}

.no-notes {
  color: #9ca3af;
  font-style: italic;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.completed {
  background: rgba(56, 161, 105, 0.1);
  color: #38a169;
}

.status-badge.failed {
  background: rgba(229, 62, 62, 0.1);
  color: #e53e3e;
}

.status-badge.in_progress {
  background: rgba(49, 130, 206, 0.1);
  color: #3182ce;
}

.status-badge.pending {
  background: rgba(214, 158, 46, 0.1);
  color: #d69e2e;
}

.status-badge.cancelled {
  background: rgba(113, 128, 150, 0.1);
  color: #718096;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.1),
    0 4px 16px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  opacity: 0.6;
}

.empty-state h3 {
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 12px 0;
}

.empty-state p {
  color: #4a5568;
  font-size: 1rem;
  margin: 0;
  line-height: 1.5;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-outline {
  background: transparent;
  color: #0D3B66;
  border: 1px solid #0D3B66;
}

.btn-outline:hover:not(:disabled) {
  background: #0D3B66;
  color: white;
}

.btn-icon {
  font-size: 1rem;
}

/* Responsive Design */
@media (max-width: 768px) {
  .google-sheets-sync-logs {
    padding: 16px;
  }

  .logs-header {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .logs-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .filter-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .filter-buttons {
    justify-content: center;
  }

  .bulk-actions-content {
    flex-direction: column;
    align-items: stretch;
  }

  .bulk-controls {
    flex-direction: column;
    gap: 8px;
  }

  .logs-table-container {
    overflow-x: auto;
  }

  .logs-table {
    min-width: 800px;
    font-size: 0.8rem;
  }

  .logs-table th,
  .logs-table td {
    padding: 12px 8px;
  }

  .logs-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .google-sheets-sync-logs {
    padding: 12px;
  }

  .logs-header {
    padding: 16px;
  }

  .header-content h2 {
    font-size: 1.5rem;
  }

  .logs-stats {
    grid-template-columns: 1fr;
  }

  .stat-card {
    padding: 16px;
  }

  .logs-table {
    min-width: 600px;
    font-size: 0.75rem;
  }

  .logs-table th,
  .logs-table td {
    padding: 8px 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/googleSheets/GoogleSheetsSyncLogs.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;;iCAE+B;EAC/B,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B;;kCAEgC;AAClC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB;;iCAE+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB;;kCAEgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/**\n * Google Sheets Sync Logs Styles\n * Modern, responsive styles for sync logs management\n */\n\n.google-sheets-sync-logs {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Header */\n.logs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  padding: 24px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.header-content h2 {\n  color: #2d3748;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  line-height: 1.2;\n}\n\n.header-content p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* Statistics */\n.logs-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow:\n    0 8px 24px rgba(0, 0, 0, 0.15),\n    0 4px 12px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card.completed .stat-icon {\n  background: linear-gradient(135deg, #38a169 0%, #2f855a 100%);\n}\n\n.stat-card.failed .stat-icon {\n  background: linear-gradient(135deg, #e53e3e 0%, #c53030 100%);\n}\n\n.stat-card.in-progress .stat-icon {\n  background: linear-gradient(135deg, #3182ce 0%, #2c5aa0 100%);\n}\n\n.stat-card.pending .stat-icon {\n  background: linear-gradient(135deg, #d69e2e 0%, #b7791f 100%);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: white;\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n}\n\n.stat-content h3 {\n  color: #4a5568;\n  font-size: 0.9rem;\n  font-weight: 600;\n  margin: 0 0 4px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.stat-value {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n  line-height: 1.2;\n}\n\n/* Filters */\n.logs-filters {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n  box-shadow:\n    0 4px 16px rgba(0, 0, 0, 0.1),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.filters-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.filters-header h3 {\n  color: #2d3748;\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.filters-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.filter-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  align-items: end;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-group.filter-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-label {\n  color: #4a5568;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-select,\n.filter-input {\n  padding: 12px 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: white;\n  color: #2d3748;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus,\n.filter-input:focus {\n  outline: none;\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.1);\n}\n\n.filter-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.logs-summary {\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 8px;\n  border: 1px solid rgba(102, 126, 234, 0.2);\n}\n\n.summary-text {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #3730a3;\n}\n\n/* Bulk Actions */\n.bulk-actions {\n  background: rgba(102, 126, 234, 0.1);\n  border: 1px solid rgba(102, 126, 234, 0.2);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 24px;\n}\n\n.bulk-actions-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.selected-count {\n  color: #2d3748;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.bulk-controls {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n/* Logs Grid */\n.logs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n/* Logs Table */\n.logs-table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: white;\n}\n\n.logs-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n  min-width: 1000px;\n}\n\n.logs-table thead {\n  background: #f8fafc;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.logs-table th {\n  padding: 16px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n}\n\n.logs-table td {\n  padding: 16px 12px;\n  border-bottom: 1px solid #f1f5f9;\n  vertical-align: top;\n  color: #374151;\n}\n\n.log-row {\n  transition: background-color 0.2s ease;\n}\n\n.log-row:hover {\n  background-color: #f8fafc;\n}\n\n.log-row:last-child td {\n  border-bottom: none;\n}\n\n.sync-type-badge {\n  background: #e0e7ff;\n  color: #3730a3;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  display: inline-block;\n}\n\n.datetime-info {\n  font-size: 0.85rem;\n  color: #374151;\n  line-height: 1.4;\n}\n\n.duration-info {\n  font-size: 0.85rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.members-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.members-count {\n  font-size: 0.85rem;\n  color: #374151;\n  font-weight: 500;\n}\n\n.failed-count {\n  font-size: 0.75rem;\n  color: #dc2626;\n}\n\n.success-rate {\n  font-size: 0.85rem;\n  color: #059669;\n  font-weight: 600;\n}\n\n.triggered-by {\n  font-size: 0.85rem;\n  color: #6b7280;\n}\n\n.notes-info {\n  max-width: 200px;\n}\n\n.notes-text {\n  font-size: 0.8rem;\n  color: #6b7280;\n  line-height: 1.3;\n  display: block;\n  word-wrap: break-word;\n}\n\n.no-notes {\n  color: #9ca3af;\n  font-style: italic;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.completed {\n  background: rgba(56, 161, 105, 0.1);\n  color: #38a169;\n}\n\n.status-badge.failed {\n  background: rgba(229, 62, 62, 0.1);\n  color: #e53e3e;\n}\n\n.status-badge.in_progress {\n  background: rgba(49, 130, 206, 0.1);\n  color: #3182ce;\n}\n\n.status-badge.pending {\n  background: rgba(214, 158, 46, 0.1);\n  color: #d69e2e;\n}\n\n.status-badge.cancelled {\n  background: rgba(113, 128, 150, 0.1);\n  color: #718096;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 16px;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.1),\n    0 4px 16px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  opacity: 0.6;\n}\n\n.empty-state h3 {\n  color: #2d3748;\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n}\n\n.empty-state p {\n  color: #4a5568;\n  font-size: 1rem;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #EA580C 0%, #FDBA74 100%);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-outline {\n  background: transparent;\n  color: #0D3B66;\n  border: 1px solid #0D3B66;\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: #0D3B66;\n  color: white;\n}\n\n.btn-icon {\n  font-size: 1rem;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .google-sheets-sync-logs {\n    padding: 16px;\n  }\n\n  .logs-header {\n    flex-direction: column;\n    gap: 16px;\n    text-align: center;\n  }\n\n  .header-actions {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .logs-stats {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n  }\n\n  .filter-row {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .filter-buttons {\n    justify-content: center;\n  }\n\n  .bulk-actions-content {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .bulk-controls {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .logs-table-container {\n    overflow-x: auto;\n  }\n\n  .logs-table {\n    min-width: 800px;\n    font-size: 0.8rem;\n  }\n\n  .logs-table th,\n  .logs-table td {\n    padding: 12px 8px;\n  }\n\n  .logs-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .google-sheets-sync-logs {\n    padding: 12px;\n  }\n\n  .logs-header {\n    padding: 16px;\n  }\n\n  .header-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .logs-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-card {\n    padding: 16px;\n  }\n\n  .logs-table {\n    min-width: 600px;\n    font-size: 0.75rem;\n  }\n\n  .logs-table th,\n  .logs-table td {\n    padding: 8px 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
